import React from 'react';
import BusquedaComitente from '../components/filtroBusquedaComitentePrincipal';

const BusquedaComitentes = () => {
    return (
       <BusquedaComitente />
    );
};

export default BusquedaComitentes;